import React, { useEffect, useMemo, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BadgeCheckIcon, XIcon } from 'lucide-react';
import { buyers, images } from '../data/landing';
import type { Buyer } from '../data/landing';
type Notice = {
  buyer: Buyer;
  minutes: number;
  id: number;
};
export function PurchasePopup() {
  const [notice, setNotice] = useState<Notice | null>(null);
  const order = useMemo(() => [...buyers].sort(() => Math.random() - 0.5), []);
  useEffect(() => {
    let index = 0;
    let hideTimer: number | undefined;
    const show = () => {
      const buyer = order[index % order.length];
      index += 1;
      setNotice({
        buyer,
        minutes: 1 + Math.floor(Math.random() * 14),
        id: index
      });
      hideTimer = window.setTimeout(() => setNotice(null), 5500);
    };
    const first = window.setTimeout(show, 6000);
    const interval = window.setInterval(show, 15000);
    return () => {
      window.clearTimeout(first);
      window.clearInterval(interval);
      if (hideTimer) window.clearTimeout(hideTimer);
    };
  }, [order]);
  return <div className="pointer-events-none fixed inset-x-3 bottom-[6.25rem] z-50 sm:inset-x-auto sm:left-5 sm:w-[22rem]" aria-live="polite" data-id="element-38" data-mp="117frg5fx9zsx">
      <AnimatePresence data-id="element-39" data-mp="1fv969nx6oyag">
        {notice && <motion.div key={notice.id} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex items-center gap-3 rounded-2xl bg-white p-3 pr-9 shadow-[0_12px_40px_-8px_rgba(6,15,31,0.35)] ring-1 ring-navy-900/10" data-id="element-40" data-mp="1awzapc7jrvob">
            <img src={images.mockup} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-cream object-contain" data-id="element-41" data-mp="s8auv4nx8gje" />
            <div className="min-w-0 text-sm leading-snug text-navy-900" data-id="element-42" data-mp="28maro6rgzq2f">
              <p data-id="element-43" data-mp="23l3j45hi6mup">
                <span className="font-extrabold" data-id="element-44" data-mp="23npobygx8q9r">{notice.buyer.name}</span> from {notice.buyer.city},{' '}
                {notice.buyer.country}
              </p>
              <p className="text-navy-900/75" data-id="element-45" data-mp="2fmcw56fd3w6x">just purchased the Hernia Clinical Playbook™</p>
              <p className="mt-0.5 flex items-center gap-1 text-xs font-semibold text-cta-600" data-id="element-46" data-mp="2ko2aow1smrzr">
                <BadgeCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-47" data-mp="2pksmh76kf1fd" />
                Verified purchase · {notice.minutes} min ago
              </p>
            </div>
            <button type="button" onClick={() => setNotice(null)} className="absolute right-2 top-2 rounded-full p-1 text-navy-900/50 transition-colors duration-150 hover:bg-cream hover:text-navy-900" aria-label="Close notification" data-id="element-48" data-mp="1wwn3opz2nmi6">
              <XIcon className="h-4 w-4" data-id="element-49" data-mp="1983wkdrrdfro" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}